module.exports = __webpack_public_path__ + "img/icon_5.45a89d82.png";